// src/cert/iso22000.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO22000 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 22000 प्रमाणन</h1>
                <p>अन्न सुरक्षा व्यवस्थापन प्रणाली (Food Safety Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO 22000 म्हणजे काय?</h2>
                    <p>
                        ISO 22000:2018 is the newly revised International Food Safety standard, designed to harmonize on a global scale the requirements for food safety management for businesses within the food chain.

                        ISO 22000 combines and supplements the core elements of ISO 9001 and HACCP to provide an effective framework for the development, implementation, monitorization and continual improvement of a documented Food Safety Management System (FSMS) within the context of the organizations overall business risks.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>अन्न विषबाधा, दूषितता आणि परतावा टाळता येतात</li>
                        <li>HACCP तत्त्वांवर आधारित जोखीम नियंत्रण</li>
                        <li>कायदेशीर अनुपालन (FSSAI, FDA, EU नियम)</li>
                        <li>ग्राहकांचा विश्वास आणि ब्रँड प्रतिष्ठा वाढते</li>
                        <li>निर्यात आणि जागतिक बाजारात प्रवेश</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 22000 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 22000" />
                </section>
            </div>
        </div>
    );
};

export default ISO22000;